/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.wizbang')
.controller('QaWizbangSaleCategoryCtrl', ["$filter", "reporttime", "$q", "$scope", "$http", "$stateParams", "title", "userinfo", "settings", function($filter, reporttime, $q, $scope, $http, $stateParams, title, userinfo, settings) {
  title.set('Sale Category Report');

  $scope.companyName = userinfo.companyName();

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaWizbangSalesSaleCategory', {
    params: {startTime: reporttime.start(), endTime: reporttime.end()}}
  );

  $scope.reportLines = [];
  $scope.unitsTotal = 0;
  $scope.priceTotal = 0;
  $scope.priceCount = 0;
  $scope.grossTotal = 0;
  $scope.discountTotal = 0;
  $scope.salesTaxTotal = 0;
  $scope.nettTotal = 0;

  var updateTotals = function(object, item) {
    object.unitsTotal += item.amountSold;
    object.priceTotal += item.averageUnitPrice;
    object.priceCount++;
    object.grossTotal += item.grossSold;
    object.discountTotal += item.discount;
    object.salesTaxTotal += item.salesTax;
    object.nettTotal += item.nettSold;
  };

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);

    // First we place the lines in a heirachy, then flatten it to make the lines in the table
    var reportOutlets = {};
    angular.forEach(response.data.lines, function(item) {
      if (!item.superItemGroupId) {
        item.superItemGroupId = -1;
      }

      if (!item.outletId) {
        item.outletId = -1;
        item.outletName = '';
      }

      if (!item.superItemGroupOrder) {
        item.superItemGroupOrder = 0;
      }

      if (!reportOutlets[item.outletId]) {
        reportOutlets[item.outletId] = {
          id: item.outletId,
          name: item.outletName,
          saleCategories: {},
          unitsTotal: 0,
          priceTotal: 0,
          grossTotal: 0,
          discountTotal: 0,
          salesTaxTotal: 0,
          nettTotal: 0
        };
      }

      if (!reportOutlets[item.outletId].saleCategories[item.saleCategoryId]) {
        reportOutlets[item.outletId].saleCategories[item.saleCategoryId] = {
          id: item.saleCategoryId,
          name: item.saleCategory,
          superItemGroups: {},
          unitsTotal: 0,
          priceTotal: 0,
          grossTotal: 0,
          discountTotal: 0,
          salesTaxTotal: 0,
          nettTotal: 0
        };
      }

      if (!reportOutlets[item.outletId].saleCategories[item.saleCategoryId].superItemGroups[item.superItemGroupId]) {
        reportOutlets[item.outletId].saleCategories[item.saleCategoryId].superItemGroups[item.superItemGroupId] = {
          id: item.superItemGroupId,
          name: item.superItemGroup,
          order: item.superItemGroupOrder,
          unitsTotal: 0,
          priceTotal: 0,
          grossTotal: 0,
          discountTotal: 0,
          salesTaxTotal: 0,
          nettTotal: 0,
          F: {
            itemGroups: {},
            unitsTotal: 0,
            priceTotal: 0,
            grossTotal: 0,
            discountTotal: 0,
            salesTaxTotal: 0,
            nettTotal: 0
          },
          B: {
            itemGroups: {},
            unitsTotal: 0,
            priceTotal: 0,
            grossTotal: 0,
            discountTotal: 0,
            salesTaxTotal: 0,
            nettTotal: 0
          }
        };
      }

      if (!reportOutlets[item.outletId].saleCategories[item.saleCategoryId]
        .superItemGroups[item.superItemGroupId][item.forb].itemGroups[item.itemGroupId]) {
        reportOutlets[item.outletId].saleCategories[item.saleCategoryId]
        .superItemGroups[item.superItemGroupId][item.forb].itemGroups[item.itemGroupId] = {
          id: item.itemGroupId,
          name: item.itemGroupAbbrev,
          order: item.itemGroupOrder,
          items: [],
          unitsTotal: 0,
          priceTotal: 0,
          grossTotal: 0,
          discountTotal: 0,
          salesTaxTotal: 0,
          nettTotal: 0
        };
      }

      reportOutlets[item.outletId].saleCategories[item.saleCategoryId]
      .superItemGroups[item.superItemGroupId][item.forb].itemGroups[item.itemGroupId].items.push({
        isItemLine: true,
        isValueLine: true,
        id: item.itemId,
        order: item.itemOrder,
        forb: item.forb,
        grp: item.itemGroupAbbrev,
        itemName: item.itemAbbrev,
        units: item.amountSold,
        price: item.averageUnitPrice,
        gross: item.grossSold,
        discount: item.discount,
        salesTax: item.salesTax,
        nett: item.nettSold
      });

      updateTotals(reportOutlets[item.outletId].saleCategories[item.saleCategoryId].superItemGroups[item.superItemGroupId][item.forb].itemGroups[item.itemGroupId], item);
      updateTotals(reportOutlets[item.outletId].saleCategories[item.saleCategoryId].superItemGroups[item.superItemGroupId][item.forb], item);
      updateTotals(reportOutlets[item.outletId].saleCategories[item.saleCategoryId].superItemGroups[item.superItemGroupId], item);
      updateTotals(reportOutlets[item.outletId].saleCategories[item.saleCategoryId], item);
      updateTotals(reportOutlets[item.outletId], item);

      $scope.unitsTotal += item.amountSold;
      $scope.priceTotal += item.averageUnitPrice;
      $scope.grossTotal += item.grossSold;
      $scope.discountTotal += item.discount;
      $scope.salesTaxTotal += item.salesTax;
      $scope.nettTotal += item.nettSold;
    });

    angular.forEach(reportOutlets, function(outlet) {
      $scope.reportLines.push({
        isHeader: true,
        headerText: outlet.name + ' - ' + $scope.companyName
      });

      angular.forEach(outlet.saleCategories, function(saleCategory) {
        $scope.reportLines.push({
          isHeader: true,
          headerText: saleCategory.name
        });

        // convert to plain array to allow sorting
        var superItemGroupsArray = [];
        angular.forEach(saleCategory.superItemGroups, function(superItemGroup) {
          superItemGroupsArray.push(superItemGroup);
        });
        angular.forEach($filter('orderBy')(superItemGroupsArray, 'order'), function(superItemGroup) {
          if (superItemGroup.name) {
            $scope.reportLines.push({
              isHeader: true,
              headerText: superItemGroup.name
            });
          }

          angular.forEach(['F', 'B'], function(forb) {
            // again to allow sorting, convert to array
            var itemGroupsArray = [];
            angular.forEach(superItemGroup[forb].itemGroups, function(itemGroup) {
              itemGroupsArray.push(itemGroup);
            });
            angular.forEach($filter('orderBy')(itemGroupsArray, 'order'), function(itemGroup) {
              angular.forEach($filter('orderBy')(itemGroup.items, 'order'), function(item) {
                $scope.reportLines.push(item);
              });

              // ItemGroup footer
              $scope.reportLines.push({
                isFooter: true,
                isValueLine: true,
                rowClass: 'totals-row',
                footerText: 'Subtotals for ' + itemGroup.name,
                units: itemGroup.unitsTotal,
                price: itemGroup.grossTotal / itemGroup.unitsTotal,
                gross: itemGroup.grossTotal,
                discount: itemGroup.discountTotal,
                salesTax: itemGroup.salesTaxTotal,
                nett: itemGroup.nettTotal
              });
            });

            // ForB footer
            $scope.reportLines.push({
              isFooter: true,
              rowClass: 'totals-row',
              isValueLine: true,
              footerText: (forb == 'F' ? 'Food' : 'Beverage') + ' Subtotals',
              units: superItemGroup[forb].unitsTotal,
              price: superItemGroup[forb].grossTotal / superItemGroup[forb].unitsTotal,
              gross: superItemGroup[forb].grossTotal,
              discount: superItemGroup[forb].discountTotal,
              salesTax: superItemGroup[forb].salesTaxTotal,
              nett: superItemGroup[forb].nettTotal
            });

          });

          if (superItemGroup.name) {
            // Super Item Group footer (but only if it's not the default super item group)
            $scope.reportLines.push({
              isFooter: true,
              rowClass: 'totals-row',
              isValueLine: true,
              footerText: superItemGroup.name + ' Subtotals',
              units: superItemGroup.unitsTotal,
              price: superItemGroup.grossTotal / superItemGroup.unitsTotal,
              gross: superItemGroup.grossTotal,
              discount: superItemGroup.discountTotal,
              salesTax: superItemGroup.salesTaxTotal,
              nett: superItemGroup.nettTotal
            });
          }

        });

        // Sale Category footer
        $scope.reportLines.push({
          isFooter: true,
          rowClass: 'totals-row',
          isValueLine: true,
          footerText: 'Subtotals for ' + saleCategory.name,
          units: saleCategory.unitsTotal,
          price: saleCategory.grossTotal / saleCategory.unitsTotal,
          gross: saleCategory.grossTotal,
          discount: saleCategory.discountTotal,
          salesTax: saleCategory.salesTaxTotal,
          nett: saleCategory.nettTotal
        });

      });

      // Outlet footer
      $scope.reportLines.push({
        isFooter: true,
        rowClass: 'totals-row',
        isValueLine: true,
        footerText: 'Subtotals for ' + outlet.name,
        units: outlet.unitsTotal,
        price: outlet.grossTotal / outlet.unitsTotal,
        gross: outlet.grossTotal,
        discount: outlet.discountTotal,
        salesTax: outlet.salesTaxTotal,
        nett: outlet.nettTotal
      });
    });
  });

}]);
